import PolicyLayout from "../components/PolicyLayout";
import { useEffect } from "react";

export default function TermsPage() {
    useEffect(() => {
        document.title = "Handelsbetingelser · Cleany.dk";
    }, []);
    return (
        <PolicyLayout title="Handelsbetingelser" lastUpdated="3. maj 2026">
            <p className="lead">
                Disse handelsbetingelser gælder for alle aftaler om brug af Cleany.dk og
                relaterede ydelser. Ved tilmelding til ventelisten eller brug af vores
                service accepterer du betingelserne.
            </p>

            <h2>1. Udbyder</h2>
            <ul>
                <li>
                    <strong>Firmanavn:</strong> Cleany.dk
                </li>
                <li>
                    <strong>CVR-nr.:</strong> 45 42 27 20
                </li>
                <li>
                    <strong>Adresse:</strong> Strevelinsvej 16, 7000 Fredericia
                </li>
                <li>
                    <strong>Email:</strong>{" "}
                    <a href="mailto:info@cleany.dk">info@cleany.dk</a>
                </li>
            </ul>

            <h2>2. Aftalegrundlag</h2>
            <p>
                Indtil Cleany går i offentlig drift den 1. oktober 2026, anses tilmelding
                til ventelisten som en uforpligtende interessetilkendegivelse. Den
                bindende abonnementsaftale indgås først, når du efter launch aktiverer
                dit abonnement og accepterer den endelige abonnementsaftale.
            </p>

            <h2>3. Priser</h2>
            <p>
                Cleanys priser er angivet på{" "}
                <a href="/#priser">priser-sektionen</a> på Cleany.dk og opdateres
                løbende. Alle priser er angivet ekskl. moms (25%).
            </p>
            <p>
                Cleany.dk forbeholder sig ret til at justere priser med 60 dages varsel.
            </p>

            <h2>4. Abonnement og betaling</h2>
            <ul>
                <li>Abonnementer faktureres månedligt forud.</li>
                <li>
                    Opstartsgebyret på 2.500 kr faktureres ved aftaleindgåelse og er et engangsbeløb (ekskl. moms).
                </li>
                <li>Alle priser er angivet ekskl. moms (25%).</li>
                <li>Betaling sker via faktura eller automatisk kortbetaling.</li>
                <li>
                    Ved manglende betaling pålægges rykkergebyr i overensstemmelse med
                    rentelovens bestemmelser.
                </li>
            </ul>

            <h2>5. Opsigelse</h2>
            <p>
                Abonnementet kan opsiges af kunden med løbende måned + 0 dages varsel.
                Du kan altid eksportere dine data i CSV-format gratis i op til 90 dage
                efter ophør.
            </p>

            <h2>6. Driftsforstyrrelser og SLA</h2>
            <p>
                Cleany.dk tilstræber 99,5 % oppetid målt over en kalendermåned, eksklusiv
                planlagt vedligeholdelse, der varsles mindst 24 timer i forvejen.
            </p>
            <p>
                Vi kan ikke holdes ansvarlige for driftsforstyrrelser, der skyldes forhold
                uden for vores rimelige kontrol, herunder leverandørfejl, internetforhold
                og force majeure.
            </p>

            <h2>7. Datasikkerhed og GDPR</h2>
            <p>
                Cleany.dk hostes i EU/EØS og overholder GDPR. Som SaaS-leverandør optræder
                vi som databehandler for kundens data. En databehandleraftale indgås
                automatisk som en del af abonnementet.
            </p>
            <p>
                Læs mere i vores{" "}
                <a href="/privatlivspolitik">privatlivspolitik</a>.
            </p>

            <h2>8. Immaterielle rettigheder</h2>
            <p>
                Alle rettigheder til Cleany.dk-platformen, herunder kildekode, design,
                grafik, varemærker og dokumentation, tilhører Cleany.dk. Brug af
                platformen giver kunden alene en ikke-eksklusiv brugsret i
                abonnementsperioden.
            </p>

            <h2>9. Ansvarsbegrænsning</h2>
            <p>
                Cleany.dk's samlede erstatningsansvar over for kunden er begrænset til
                det beløb, kunden har betalt for abonnementet i de seneste 12 måneder
                forud for det skadevoldende forhold. Vi er aldrig ansvarlige for
                indirekte tab, herunder driftstab, tabt fortjeneste eller tab af data.
            </p>

            <h2>10. Ændringer i betingelser</h2>
            <p>
                Vi kan opdatere disse handelsbetingelser med 30 dages varsel pr. e-mail
                til kontaktpersonen registreret på abonnementet. Du har til enhver tid
                ret til at opsige abonnementet, hvis du ikke ønsker at acceptere
                ændringerne.
            </p>

            <h2>11. Lovvalg og værneting</h2>
            <p>
                Aftaler indgået med Cleany.dk er underlagt dansk ret. Tvister, som ikke
                kan løses ved forhandling, skal afgøres ved Retten i Kolding som første
                instans.
            </p>
        </PolicyLayout>
    );
}
